module.exports = __webpack_public_path__ + "media/CARNET3.7029a993.mp4";